"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleConversionNameToActionId = exports.GoogleConversionAdjustmentType = exports.GoogleConversionName = void 0;
var GoogleConversionName;
(function (GoogleConversionName) {
    GoogleConversionName["lead"] = "lead";
    GoogleConversionName["prequalified"] = "prequalified";
    GoogleConversionName["acceptPrequal"] = "acceptPrequal";
    GoogleConversionName["viewOffer"] = "viewOffer";
    GoogleConversionName["acceptOffer"] = "acceptOffer";
    GoogleConversionName["schedule"] = "schedule";
    GoogleConversionName["primaryCreditCardCreated"] = "primaryCreditCardCreated";
    GoogleConversionName["avenCashPQ"] = "avenCashPQ";
    // v3 HELOC funnel conversions with updated pricing (fixed lead/pii by MOAP/AC; formula-based pq/pqa/booked by AC/MOAP/REFI)
    GoogleConversionName["leadV3"] = "leadV3";
    GoogleConversionName["piiV3"] = "piiV3";
    GoogleConversionName["prequalifiedV3"] = "prequalifiedV3";
    GoogleConversionName["acceptPrequalV3"] = "acceptPrequalV3";
    GoogleConversionName["bookedV3"] = "bookedV3";
    // advisor events
    GoogleConversionName["advisorHomeownerLead"] = "advisorHomeownerLead";
    GoogleConversionName["advisorPhoneNumberSubmit"] = "advisorPhoneNumberSubmit";
    GoogleConversionName["advisorOTPSuccess"] = "advisorOTPSuccess";
    GoogleConversionName["advisorSSNSuccess"] = "advisorSSNSuccess";
    GoogleConversionName["advisorPIISuccess"] = "advisorPIISuccess";
    GoogleConversionName["advisorKBASuccess"] = "advisorKBASuccess";
    GoogleConversionName["advisorHomeownerKBASuccess"] = "advisorHomeownerKBASuccess";
    GoogleConversionName["advisorNotificationPermissionGranted"] = "advisorNotificationPermissionGranted";
    GoogleConversionName["advisorStatedGoalSubmit"] = "advisorStatedGoalSubmit";
    GoogleConversionName["advisorStatedGoalLienReports"] = "advisorStatedGoalLienReports";
    GoogleConversionName["advisorStatedGoalBudgetSpendTracking"] = "advisorStatedGoalBudgetSpendTracking";
    GoogleConversionName["advisorStatedGoalFindSubscriptions"] = "advisorStatedGoalFindSubscriptions";
    GoogleConversionName["advisorStatedGoalCreditScore"] = "advisorStatedGoalCreditScore";
    GoogleConversionName["advisorStatedGoalOther"] = "advisorStatedGoalOther";
})(GoogleConversionName || (exports.GoogleConversionName = GoogleConversionName = {}));
var GoogleConversionAdjustmentType;
(function (GoogleConversionAdjustmentType) {
    // To adjusting the value of a conversion
    GoogleConversionAdjustmentType["RESTATEMENT"] = "RESTATEMENT";
    // There are more but we're not using them so far: https://developers.google.com/google-ads/api/rest/reference/rest/v16/customers/uploadConversionAdjustments#ConversionAdjustmentType
})(GoogleConversionAdjustmentType || (exports.GoogleConversionAdjustmentType = GoogleConversionAdjustmentType = {}));
exports.GoogleConversionNameToActionId = {
    [GoogleConversionName.lead]: '6822101196',
    [GoogleConversionName.prequalified]: '6822101199',
    [GoogleConversionName.acceptPrequal]: '6822101202',
    [GoogleConversionName.viewOffer]: '6822101205',
    [GoogleConversionName.acceptOffer]: '6827432110',
    [GoogleConversionName.schedule]: '6827432113',
    [GoogleConversionName.primaryCreditCardCreated]: '6827432116',
    [GoogleConversionName.avenCashPQ]: '6830012285',
    // TODO: replace these placeholders with the real Google Ads conversion action IDs created in the Google Ads UI for the v3 funnel.
    [GoogleConversionName.leadV3]: '7666586609',
    [GoogleConversionName.piiV3]: '7666595735',
    [GoogleConversionName.prequalifiedV3]: '7666974216',
    [GoogleConversionName.acceptPrequalV3]: '7666984690',
    [GoogleConversionName.bookedV3]: '7666985019',
    [GoogleConversionName.advisorHomeownerLead]: '6864502446',
    [GoogleConversionName.advisorPhoneNumberSubmit]: '6882140060',
    [GoogleConversionName.advisorOTPSuccess]: '6882140063',
    [GoogleConversionName.advisorSSNSuccess]: '6882140066',
    [GoogleConversionName.advisorPIISuccess]: '6882140069',
    [GoogleConversionName.advisorKBASuccess]: '6882140072',
    [GoogleConversionName.advisorNotificationPermissionGranted]: '6882140075',
    [GoogleConversionName.advisorStatedGoalSubmit]: '6882140078',
    [GoogleConversionName.advisorStatedGoalLienReports]: '6882140081',
    [GoogleConversionName.advisorStatedGoalBudgetSpendTracking]: '6882140087',
    [GoogleConversionName.advisorStatedGoalFindSubscriptions]: '6882140084',
    [GoogleConversionName.advisorStatedGoalCreditScore]: '6882140090',
    [GoogleConversionName.advisorStatedGoalOther]: '6882140093',
    [GoogleConversionName.advisorHomeownerKBASuccess]: '6917376146',
};
